import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { GraphqlService } from '../../services/graphql.service';
import { GET_FAQS } from '../accounts/admin/faq-management/faq.graphql';
import { FAQCategory, FAQ_CATEGORY_ORDER, normalizeFaqCategory } from '../accounts/admin/faq-management/faq.model';

export interface FaqItem {
  question: string;
  answer: string;
  category: FAQCategory;
}

@Component({
  selector: 'app-faqs',
  imports: [
    SharedModule,
    TranslateModule,
  ],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss',
})
export class FaqsComponent implements OnInit {
  faqCategories: FAQCategory[] = FAQ_CATEGORY_ORDER.slice();
  selectedCategory: FAQCategory = FAQCategory.GENERAL;
  faqs: FaqItem[] = [];
  activeQuestionIndex: number | null = null;

  constructor(private apollo: GraphqlService) { }

  async ngOnInit() {
    await this.loadFaqs();
  }

  async loadFaqs() {
    try {
      const result = await this.apollo.query({
        query: GET_FAQS,
        variables: {
          filtering: {
            isActive: true,
            isPublished: true,
            pageNumber: 1,
            pageSize: 100,
          },
        },
      });

      const items = result?.data?.getFaqs?.data || [];
      this.faqs = items.map((item: any) => ({
        question: item.question,
        answer: item.answer,
        category: normalizeFaqCategory(item.category),
      }));

      const orderedCategories = FAQ_CATEGORY_ORDER.filter((category) =>
        this.faqs.some((faq) => faq.category === category)
      );
      const otherCategories = Array.from(
        new Set(this.faqs.map((faq) => faq.category))
      ).filter((category) => !orderedCategories.includes(category));
      this.faqCategories = [...orderedCategories, ...otherCategories];

      if (!this.faqCategories.includes(this.selectedCategory)) {
        this.selectedCategory = this.faqCategories[0] || FAQCategory.GENERAL;
      }

      this.activeQuestionIndex = null;
    } catch (error) {
      console.error('FAQ error:', error);
      this.faqs = [];
      this.faqCategories = FAQ_CATEGORY_ORDER.slice();
      this.selectedCategory = FAQCategory.GENERAL;
      this.activeQuestionIndex = null;
    }
  }

  get categoryFaqs() {
    return this.faqs.filter((faq) => faq.category === this.selectedCategory);
  }

  selectCategory(category: FAQCategory) {
    this.selectedCategory = category;
    this.activeQuestionIndex = null;
  }

  toggleQuestion(index: number) {
    this.activeQuestionIndex = this.activeQuestionIndex === index ? null : index;
  }
}
